import { render, staticRenderFns } from "./TableSetting.vue?vue&type=template&id=108abd5c&scoped=true&"
import script from "./TableSetting.vue?vue&type=script&lang=ts&"
export * from "./TableSetting.vue?vue&type=script&lang=ts&"
import style0 from "./TableSetting.vue?vue&type=style&index=0&id=108abd5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108abd5c",
  null
  
)

export default component.exports